import { render, staticRenderFns } from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=template&id=7eda7273&scoped=true"
import script from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eda7273",
  null
  
)

export default component.exports